import { IApplicationState } from '../../types/redux';
import { getFilters } from './getFilters';

export function getFilterLocation(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.location;
}
